import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'

const withContainer = Component => ({ row, ...props }) => {
  const service_blacklist_id = _.get(row, 'service_blacklist_id')
  const [deleteRecord] = hooks.useModelFunction('serviceblacklist', 'delete')
  const onDelete = useCallback(() => deleteRecord({ service_blacklist_id })
    , [service_blacklist_id])

  const mergedProps = {
    row,
    onDelete
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
